import { Controller } from "@hotwired/stimulus"

// Multi-item AJAX search with chip-based selection.
// Usage:
//   data-controller="complaint-multiselect"
//   data-complaint-multiselect-url-value="/path/to/search"
//   data-complaint-multiselect-param-name-value="complaint[order_ids][]"
//   Initial values: data-complaint-multiselect-initial-value='[{"id":1,"label":"..."}]'
export default class extends Controller {
  static targets = ["input", "results", "chips", "hidden"]
  static values  = { url: String, paramName: String, initial: Array }

  connect() {
    this.selectedIds = new Set()
    this.initialValue.forEach(item => this._addItem(item))
    document.addEventListener("click", this._closeResults)
  }

  disconnect() {
    document.removeEventListener("click", this._closeResults)
  }

  _closeResults = (e) => {
    if (!this.element.contains(e.target)) this.resultsTarget.innerHTML = ""
  }

  search() {
    clearTimeout(this._timer)
    const term = this.inputTarget.value.trim()
    if (term.length < 2) { this.resultsTarget.innerHTML = ""; return }
    this._timer = setTimeout(() => {
      fetch(`${this.urlValue}?term=${encodeURIComponent(term)}`, { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(r => r.json())
        .then(items => this._showResults(items))
    }, 250)
  }

  _showResults(items) {
    this.resultsTarget.innerHTML = ""
    const visible = items.filter(i => !this.selectedIds.has(String(i.id)))
    if (!visible.length) { this.resultsTarget.innerHTML = "<div class='p-1 text-muted small'>Nic nenalezeno</div>"; return }
    visible.forEach(item => {
      const div = document.createElement("div")
      div.className = "p-1 px-2 autocomplete-item"
      div.textContent = item.label
      div.addEventListener("mousedown", (e) => { e.preventDefault(); this._addItem(item) })
      this.resultsTarget.appendChild(div)
    })
  }

  _addItem(item) {
    const id = String(item.id)
    if (this.selectedIds.has(id)) return
    this.selectedIds.add(id)

    const chip = document.createElement("span")
    chip.className = "badge badge-secondary mr-1 mb-1 d-inline-flex align-items-center"
    chip.dataset.id = id
    chip.innerHTML = `${item.label}&nbsp;<a href="#" style="color:white;text-decoration:none;font-weight:bold" data-id="${id}">&times;</a>`
    chip.querySelector("a").addEventListener("click", (e) => { e.preventDefault(); this._removeItem(id) })
    this.chipsTarget.appendChild(chip)

    const hidden = document.createElement("input")
    hidden.type  = "hidden"
    hidden.name  = this.paramNameValue
    hidden.value = id
    hidden.dataset.id = id
    this.hiddenTarget.appendChild(hidden)

    this.inputTarget.value  = ""
    this.resultsTarget.innerHTML = ""
  }

  _removeItem(id) {
    this.selectedIds.delete(id)
    this.chipsTarget.querySelector(`[data-id="${id}"]`)?.remove()
    this.hiddenTarget.querySelector(`[data-id="${id}"]`)?.remove()
  }
}
